import React, { Component } from "react";
import Search from "../searchComponent";
import { ALL, FAVOURITE, RECENT } from "../../../store/types";
import TableData from "../tableData";
import { connect } from "react-redux";
import { getInvestors, storeType } from "../../../store/actions";
import TabHeader from "../../forms/tabHeader";

class InvestorData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'M',
      activeText: "All",
    };
  }

  async componentDidMount() {
    const response = await this.props.getInvestors({
      ARN: this.props.token,
      AllFavFlag: "A",
      customfund:"189",
      
    });
  }

  selectTab = (tabName) => async () => {
    this.props.storeType(tabName);
    console.log(tabName);
    this.setState({
      activeTab: tabName ,
      activeText:
        tabName === "M" ? "All" : tabName === RECENT ? "Recent" : "Favourite",
    });

    await this.props.getInvestors({
      ARN: this.props.token,
      AllFavFlag: tabName==="M"?"A":tabName,
      customfund:"189"
    });
  };

  render() {
    const { activeTab } = this.state;
    return (
      <div className="investor-serach-container">
        <Search history={this.props.history} />
        <div
          className="investor-tab"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            className="tab-container"
            style={{
              justifyContent: "flex-start",
              flexGrow:1,
              flexBasis:0,
              margin: "25px 20px 15px 20px",
            }}
          >
            <TabHeader
              value="ALL"
              active={activeTab === "M"}
              onClick={this.selectTab("M")}
            />
            <TabHeader
              value="FAVOURITE"
              active={activeTab === FAVOURITE}
              onClick={this.selectTab(FAVOURITE)}
            />
            <TabHeader
              value="RECENT"
              active={activeTab === RECENT}
              onClick={this.selectTab(RECENT)}
            />
          </div>
          <div className="investors-count-box">
            <div
              style={{
                fontSize: 14,
                fontFamily: "Rubik-Regular",
                backgroundColor: "#EEEEEE",
                padding: "7px 30px",
              }}
            >
              {this.state.activeText} : {this.props.count} Investors
            </div>
          </div>
        </div>
        <TableData
          history={this.props.history}
          location={this.props.location}
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer, investor }) => {
    const { token } = authReducer;
    const { count } = investor;
    return { token, count };
  },
  { getInvestors, storeType }
)(InvestorData);
